import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "database-item",
  templateUrl: "./database-item.component.html",
})
export class DatabaseItemComponent implements OnInit {

  @Input() public serviceId: string;
  @Input() public bot: any;
  @Input() public externalInstances: any;
  @Input() public selectedInstance: any;
  @Input() public botLocations: any;
  @Input() public localInstance: any;
  public instanceLocations: any[] = [];
  public servicesFilter: any;
  @Output() public locationChanged: EventEmitter<any> = new EventEmitter();

  constructor(
    public router: Router,
  ) { }

  public ngOnInit(): void {
    this.initLocations();
  }

  public initLocations(): void {
    this.instanceLocations = [];
    if (this.externalInstances && this.externalInstances.length) {
      this.externalInstances.forEach((ei) => {
        const current = this.botLocations.filter((bl) => bl.serverId === ei.externalServer.id);
        if (current.length) {
          this.instanceLocations.push(current[0]);
        } else {
          this.instanceLocations.push({
            serverId: ei.externalServer.id,
            externalServiceId: "",
          });
        }
      });
    }
    if (this.bot.category && this.bot.category !== "other") {
      this.servicesFilter = {
        id: this.bot.category,
      };
    }
  }

  public checkDBType(remote) {
    return this.formatSuffix(this.bot.botServiceId) === this.formatSuffix(remote);
  }

  public formatSuffix(name) {
    const tempName = name.replaceAll("_", "-").replaceAll(" ", "-");
    const suffix = tempName ? tempName.split("-")[tempName.split("-").length - 1] : "";
    return ` ${suffix.replaceAll("-", " ")}`;
  }

  public onLocationChange(e, node): void {
    this.instanceLocations[0].externalServiceId = e;
    this.locationChanged.emit({
      botId: this.bot.id,
      locations: this.instanceLocations,
    });
  }

  public formatName(serviceName): string {
    serviceName = serviceName.replace(/GDB.GDB-/gi, "");
    serviceName = serviceName.replace(/GDB-/gi, "");
    serviceName = serviceName.replace(/GDB./gi, "");
    return serviceName;
  }

  public navigateBot(): void {
    this.router.navigate(["/services/" + this.serviceId + "/bots/" + this.bot.id]);
  }
}
